import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  error: {
    id: 'studio.HFwnMq',
    defaultMessage: 'Something went wrong loading this resource',
  },
  loading: {
    id: 'studio.XcSHdk',
    defaultMessage: 'Loading resource…',
  },
  loadingEditor: {
    id: 'studio.5rQbww',
    defaultMessage: 'Loading editor…',
  },
  json: {
    id: 'studio.l3dsTi',
    defaultMessage: 'Resource as JSON',
  },
  properties: {
    id: 'studio.aI80kg',
    defaultMessage: 'Properties',
  },
  history: {
    id: 'studio.djJp6c',
    defaultMessage: 'History',
  },
  edit: {
    id: 'studio.s3IOQQ',
    defaultMessage: 'Edit {name}',
  },
  updateSuccess: {
    id: 'studio.71o4N1',
    defaultMessage: 'Successfully updated resource {id}.',
  },
  updateError: {
    id: 'studio.hB8k+Z',
    defaultMessage: 'Something went wrong when updating this resource.',
  },
  save: {
    id: 'studio.jvo0vs',
    defaultMessage: 'Save',
  },
  copy: {
    id: 'studio.oYcgWT',
    defaultMessage: 'Copy the resource JSON to clipboard',
  },
  download: {
    id: 'studio.9oTFxb',
    defaultMessage: 'Download the resource JSON',
  },
  copySuccess: {
    id: 'studio.y9Afg8',
    defaultMessage: 'Successfully copied the resource to clipboard.',
  },
  copyError: {
    id: 'studio.yAQvyu',
    defaultMessage: 'Something went wrong when copying the resource to the clipboard.',
  },
});
